import { ReactNode } from "react";

interface HeaderTitleProps {
  title: string;
  children?: ReactNode;
}

export default function HeaderTitle({ title, children }: HeaderTitleProps) {
  return (
    <div className="flex items-center pb-6 gap-4">
      <h6 className="text-body-text text-base font-semibold uppercase">
        {title}
      </h6>

      <div className="border-b-2 border-dashed border-display-medium/50 flex-1 w-full" />
      {children}
    </div>
  );
}
